import { permissoes, routesNames } from '@/core/constants'
import GestaoDaAtaView from '@/views/pages/ata/acessar/gestao-da-ata/GestaoDaAtaView.vue'
import GestaoDaAtaInternas from '@/views/routers/routes/ata/gestao-da-ata/gestao-da-ata-internas'

export default {
	name: routesNames.ATA.ATA_ACESSAR_GESTAO_ATA_VIEW,
	path: 'gestao-da-ata/',
	component: GestaoDaAtaView,
	redirect: (to) => {
		return { name: routesNames.ATA.ATA_ACESSAR_ITENS_VIEW, params: to.params }
	},
	meta: {
		page: {
			title: 'Ata de Registro de Preço',
			subtitle: 'Gestão da Ata',
		},
		requiresAuth: true,
		authorities: [permissoes.ataVisualizar, permissoes.ataEditar],
	},
	children: [...GestaoDaAtaInternas],
}
